import React, { useEffect, useState, useRef } from "react";
import { Layout, List, Avatar, Spin, Typography, Card, Drawer, Button, Grid, Input , Image} from "antd";
import { MenuOutlined , SendOutlined,FileUnknownOutlined} from "@ant-design/icons";
import Sider from "antd/es/layout/Sider";

import callAPI from "../../comps/fetch/main";
import { set } from "lodash";

const { Content } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;
const { TextArea } = Input;
const { Paragraph } = Typography;




function ChatMessage({ msg, isSender }) {
    console.log("mesage" , isSender)
  const renderContent = () => {

    if(msg.is_unsupported)
         {
           return <Text type="secondary" style={{ display: "block", marginTop: 4 }}>
              This item not supported.
            </Text>
         }
    // ✅ If text message
    if (msg.message) {
      return (
        <Paragraph
          style={{ margin: 0 }}
          ellipsis={false}
          copyable={false}
          linkable
        >
          {/* auto linkify */}
          <a href={msg.message.match(/https?:\/\/[^\s]+/)?.[0]} target="_blank" rel="noreferrer">
            {msg.message}
          </a>
        </Paragraph>
      );
    }

    // ✅ If attachments exist
    if (msg.attachments?.data?.length) {
      return msg.attachments.data.map((att) => {
        if (att?.image_data) {
          return (
            <Image
              key={att.id}
              src={att.image_data?.preview_url}
              maxWidth="600px"
              maxHeight="auto"

              style={{ borderRadius: 8 ,maxWidth :"600px", maxHeight:"600px"}}
              alt="attachment"
            />
          );
        }
        if (att?.video_data) {
          return (
            <video
              key={att.id}
              src={att.video_data?.url}
              poster={att.video_data?.preview_url}
              style={{ borderRadius: 8 ,maxWidth :"600px", maxHeight:"600px"}}
              controls
            />
          );
        }
        return <Paragraph key={att.id}>Unsupported file</Paragraph>;
      });
    }

    return null;
  };

  return (
    <Card
      style={{
        alignSelf: isSender ? "flex-end" : "flex-start",
        background: isSender ? "#e6f7ff" : "#f5f5f5",
        maxWidth: "70%",
      }}
      bodyStyle={{ padding: 12 }}
    >
      {renderContent()}
    </Card>
  );
}


export default function MessengerPage() {
  const screens = useBreakpoint();
//   const [loading, setLoading] = useState(true);
  const [conversations, setConversations] = useState([]);
  const[conversationsAfter, setConversationsAfter] = useState()
  const[chatsAfter, setChatsAfter] = useState()

  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const messagesEndRef = useRef(null);

  const [loadMoreConversations, setLoadMoreConversations] = useState(true)
  const [loadMoreChats, setLoadMoreChats] = useState(true)

  const [loadingConversations, setLoadingConversations] = useState(false)
  const [loadingChats, setLoadingChats] = useState(false)




    useEffect(() => {
          console.log("Calling POSTS API")
  
          if (loadingConversations == true){
              //  || data?.auto_reply?.comment_reply?.all_posts == "true") {
              return
          }
          if (loadMoreConversations == false ) {
            return
          }
  
          let apiURL = ""
  
          // apiURL = "ig-stories"
          apiURL = "ig-messages"
  
          if (conversationsAfter) {
              apiURL += `?after=${conversationsAfter}`
  
          }
  
          callAPI({ url: apiURL, method: "GET", loadingState: setLoadingConversations, dataState: (data) => {
            setConversations([...conversations , ...(data?.data|| []) ])
            setConversationsAfter(data?.paging?.after)
            setLoadingConversations(false)
          } })
    
          setLoadMoreConversations(false)
  
      }, [loadMoreConversations])
  

    useEffect(() => {


        if (loadingChats == true){
              //  || data?.auto_reply?.comment_reply?.all_posts == "true") {
              return
          }
          setMessages([])

          console.log()
  
          let apiURL = ""
  
          // apiURL = "ig-stories"
          apiURL = "ig-convos?conv_id="+selectedConversation?.id
  
          if (chatsAfter && messages?.length > 0) {
              apiURL += `&after=${chatsAfter}`
  
          }
  
          callAPI({ url: apiURL, method: "GET", loadingState: setLoadingChats, dataState: (data) => {
            setMessages([...messages , ...(data?.messages?.reverse()|| []) ])
            setChatsAfter(data?.paging?.after)
            setLoadingChats(false)
          } })
    
          setLoadMoreChats(false)
//         setMessages(data?.reverse())


    },[selectedConversation])

    useEffect( () => {
        console.log("=-=-=-=-=-" , messages)
    },[messages])

  // Fetch messages when a conversation is selected
//   useEffect(() => {
//     async function fetchMessages() {
//       if (!selectedConversation) return;
//       setMessagesLoading(true);
//       try {
//         // const res = await axios.get(
//         //   `/api/conversations/${selectedConversation.id}/messages`
//         // );
//         // setMessages(res.data.data || []);
//         let data = [
//       {
//         "attachments": {
//           "data": [
//             {
//               "mime_type": "video/mp4",
//               "video_data": {
//                 "width": 720,
//                 "height": 1280,
//                 "length": 3,
//                 "video_type": 1,
//                 "url": "https://scontent.fmaa1-4.fna.fbcdn.net/v/t42.3356-2/552539390_24430829043282780_1038875842727582496_n.mp4?_nc_cat=106&cb=c2fcdba8-a66f7739&ccb=1-7&_nc_sid=4f86bc&_nc_ohc=jf0lZWS2keIQ7kNvwFHraAS&_nc_oc=AdlEBwYYsk3owCwFsGEY8GtR5_Gav1tvaAFc1BGD6I6lJ7fVWeHZ7UqaWuwDlmwwPw8&_nc_zt=28&_nc_ht=scontent.fmaa1-4.fna&edm=AFbNatQEAAAA&_nc_gid=-3RF2Fvow279V3fk5Wo4bA&oh=03_Q7cD3QGwTmRheEEfWiNptaG2rxwefhFCFrSqUa4fwsqPa4xK4Q&oe=68D806FA&dl=1",
//                 "preview_url": "https://scontent.fmaa1-2.fna.fbcdn.net/v/t15.3394-10/554676135_24379845121665748_8480564007410764976_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=f10757&_nc_ohc=0ehrW3NPPI8Q7kNvwGImjKO&_nc_oc=AdlUeYffIIAHtEbpcAkUZ4OZDWUakMts6s0HnLZgKcjrkf2G9dYDw4kgtYA7q8PBIPI&_nc_zt=23&_nc_ht=scontent.fmaa1-2.fna&edm=AFbNatQEAAAA&_nc_gid=-3RF2Fvow279V3fk5Wo4bA&oh=03_Q7cD3QEsZ6vS0CNcoMJ0yJpYW6QxCMCMVSf1Y8l4Lp7fIrWJnw&oe=68DC1740",
//                 "rotation": 0
//               },
//               "id": "1431809938116621"
//             }
//           ],
//           "paging": {
//             "cursors": {
//               "before": "MAZDZD",
//               "after": "MAZDZD"
//             },
//             "next": "https://graph.facebook.com/v23.0/m_X2eALxy0AczIva7QbslFn2WzZp7VxuqMBumloBfdyockl65_Yv_Er41VLt4SFw4hk8d42X-D4ES3GF1J0dq1bA/attachments?access_token=EAAGJ8ncRr0oBPkHQ4DU9N824Oki7N39eMLQNersZCDa86keQCONdSZAhVIpbcn0WCELlsIqqcLytQ3eI0TMgbx7UDP8QBpF4QKm9qvs0apn3zwoD6IoEZAswokZB24Is9Vy8KHVbKeawTrVA5GuLZCbgfBFQhuVfyrMBnlazpWrgpvzDXGTFrkVh6gm2hXXyOVLCvZAkghk8WyK5bKhl19doeilMqA20CcIYhRQNQZD&pretty=0&fields=mime_type%2Cfile_url%2Cimage_data%2Cvideo_data&limit=25&after=MAZDZD"
//           }
//         },
//         "message": "",
//         "to": {
//           "data": [
//             {
//               "name": "Instantdm",
//               "email": "402280506295644@facebook.com",
//               "id": "402280506295644"
//             }
//           ]
//         },
//         "id": "m_X2eALxy0AczIva7QbslFn2WzZp7VxuqMBumloBfdyockl65_Yv_Er41VLt4SFw4hk8d42X-D4ES3GF1J0dq1bA"
//       },
//       {
//         "attachments": {
//           "data": [
//             {
//               "mime_type": "image/jpeg",
//               "image_data": {
//                 "width": 376,
//                 "height": 257,
//                 "max_width": 376,
//                 "max_height": 257,
//                 "url": "https://scontent.fmaa1-5.fna.fbcdn.net/v/t1.15752-9/552989122_1464583504778727_8004971541719276661_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=fc17b8&_nc_ohc=xdTwNISTkcsQ7kNvwHAFE5Y&_nc_oc=AdlpYgoMX_5uRFrVwMV7TKazqItr4vFa2vs8wpED7g5UuoSqVo1I70Vs0sW1n9HaZ7Y&_nc_zt=23&_nc_ht=scontent.fmaa1-5.fna&edm=AFbNatQEAAAA&oh=03_Q7cD3QFihRLdGIYfJ8cYG0ZUCD__jmQBkmjt2Z5qE7Dq8okDqA&oe=68FDBCC4",
//                 "preview_url": "https://scontent.fmaa1-5.fna.fbcdn.net/v/t1.15752-9/552989122_1464583504778727_8004971541719276661_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=fc17b8&_nc_ohc=xdTwNISTkcsQ7kNvwHAFE5Y&_nc_oc=AdlpYgoMX_5uRFrVwMV7TKazqItr4vFa2vs8wpED7g5UuoSqVo1I70Vs0sW1n9HaZ7Y&_nc_zt=23&_nc_ht=scontent.fmaa1-5.fna&edm=AFbNatQEAAAA&oh=03_Q7cD3QFihRLdGIYfJ8cYG0ZUCD__jmQBkmjt2Z5qE7Dq8okDqA&oe=68FDBCC4",
//                 "image_type": 1,
//                 "render_as_sticker": false
//               },
//               "id": "1464583501445394"
//             }
//           ],
//           "paging": {
//             "cursors": {
//               "before": "MAZDZD",
//               "after": "MAZDZD"
//             },
//             "next": "https://graph.facebook.com/v23.0/m_zK7RxuRnFb_845FFiidXT2WzZp7VxuqMBumloBfdyoebeMBD7x8UI16-MwS6SeELd7Q3PpQFSTCkdcYK450sgg/attachments?access_token=EAAGJ8ncRr0oBPkHQ4DU9N824Oki7N39eMLQNersZCDa86keQCONdSZAhVIpbcn0WCELlsIqqcLytQ3eI0TMgbx7UDP8QBpF4QKm9qvs0apn3zwoD6IoEZAswokZB24Is9Vy8KHVbKeawTrVA5GuLZCbgfBFQhuVfyrMBnlazpWrgpvzDXGTFrkVh6gm2hXXyOVLCvZAkghk8WyK5bKhl19doeilMqA20CcIYhRQNQZD&pretty=0&fields=mime_type%2Cfile_url%2Cimage_data%2Cvideo_data&limit=25&after=MAZDZD"
//           }
//         },
//         "message": "",
//         "to": {
//           "data": [
//             {
//               "name": "Instantdm",
//               "email": "402280506295644@facebook.com",
//               "id": "402280506295644"
//             }
//           ]
//         },
//         "id": "m_zK7RxuRnFb_845FFiidXT2WzZp7VxuqMBumloBfdyoebeMBD7x8UI16-MwS6SeELd7Q3PpQFSTCkdcYK450sgg"
//       },
//       {
//         "message": "Of course, what is your budget for the gift?",
//         "to": {
//           "data": [
//             {
//               "name": "Sanjay KhanSsk",
//               "email": "9921834527916767@facebook.com",
//               "id": "9921834527916767"
//             }
//           ]
//         },
//         "id": "m_sA6EMMxatJnSaWZ14MmIVGWzZp7VxuqMBumloBfdyocFNe2YuEYOZp1_KX1YSkZPSjRRiSkbaFKZkxXsE2tiIw"
//       },
//       {
//         "message": "Of course, what is your budget for the gift?",
//         "to": {
//           "data": [
//             {
//               "name": "Sanjay KhanSsk",
//               "email": "9921834527916767@facebook.com",
//               "id": "9921834527916767"
//             }
//           ]
//         },
//         "id": "m_DEcuEXuYRnK-eBXQWZODpGWzZp7VxuqMBumloBfdyofPd9ktCMvFDSaLgV3jYeQ42tBl_G5xpJjuW-BiDVlnQA"
//       },
//       {
//         "message": "LESS THAN $20",
//         "to": {
//           "data": [
//             {
//               "name": "Instantdm",
//               "email": "402280506295644@facebook.com",
//               "id": "402280506295644"
//             }
//           ]
//         },
//         "id": "m_b_glrRROSSZjz2MfI_SLfGWzZp7VxuqMBumloBfdyofjikZTiJhO7n3rcMp1HdnO777dn_Q51d7FnvU30DQGTw"
//       },
//       {
//         "message": "LESS THAN $20",
//         "to": {
//           "data": [
//             {
//               "name": "Instantdm",
//               "email": "402280506295644@facebook.com",
//               "id": "402280506295644"
//             }
//           ]
//         },
//         "id": "m_vpH-ChWm2044f-n9Bxr-12WzZp7VxuqMBumloBfdyocH-s4JFKukP0Pn2lhYzknn3uZNBBIj3JBBq5vrdxtTEA"
//       },
//       {
//         "message": "LESS THAN $20",
//         "to": {
//           "data": [
//             {
//               "name": "Instantdm",
//               "email": "402280506295644@facebook.com",
//               "id": "402280506295644"
//             }
//           ]
//         },
//         "id": "m_6aZmVpUdX9LEG1swvAQ5mWWzZp7VxuqMBumloBfdyodc_SvNpuDMAXXFS1ME0iIkKK2IpkwCMx0jk_HRzx_Tpg"
//       },
//       {
//         "message": "LESS THAN $20",
//         "to": {
//           "data": [
//             {
//               "name": "Instantdm",
//               "email": "402280506295644@facebook.com",
//               "id": "402280506295644"
//             }
//           ]
//         },
//         "id": "m_PJ5pNtujushta4osJn4SpWWzZp7VxuqMBumloBfdyoev_FcF7HBq0FkbuQn70PbwmBcbJsPNF5pTHvhXSx-0ig"
//       },
//       {
//         "message": "Of course, what is your budget for the gift?",
//         "to": {
//           "data": [
//             {
//               "name": "Sanjay KhanSsk",
//               "email": "9921834527916767@facebook.com",
//               "id": "9921834527916767"
//             }
//           ]
//         },
//         "id": "m_fFFveaF3c8_b-Kfsjuo3tmWzZp7VxuqMBumloBfdyodac1dbA2Y9FmnqRf8srCf-G2gz5XdK3mgWKj4UguwgsA"
//       },
//       {
//         "message": "You are responding to a user comment to a post on your Page. View comment.(https://facebook.com/61562808285911/posts/122141459786426942/?comment_id=23869995759343092)",
//         "to": {
//           "data": [
//             {
//               "name": "Sanjay KhanSsk",
//               "email": "9921834527916767@facebook.com",
//               "id": "9921834527916767"
//             }
//           ]
//         },
//         "id": "m_mDyZ9MUF1pUWn2W8-WI4k2WzZp7VxuqMBumloBfdyoduszF06Dabzf1oI-Ff6XiFKRZMQ0Xcc2_nF355CvcjtA"
//       },
//       {
//         "message": "hey",
//         "to": {
//           "data": [
//             {
//               "name": "Sanjay KhanSsk",
//               "email": "9921834527916767@facebook.com",
//               "id": "9921834527916767"
//             }
//           ]
//         },
//         "id": "m_OA-GponYfWeZ4vET7ltgGmWzZp7VxuqMBumloBfdyoddY2Kpmgy3mRSaxiFlR6gcZC7sr-uoc98aE_cWhWORJg"
//       },
//       {
//         "message": "You are responding to a user comment to a post on your Page. View comment.(https://facebook.com/61562808285911/posts/122141459786426942/?comment_id=1498536971597195)",
//         "to": {
//           "data": [
//             {
//               "name": "Sanjay KhanSsk",
//               "email": "9921834527916767@facebook.com",
//               "id": "9921834527916767"
//             }
//           ]
//         },
//         "id": "m_0WjqxxjYRYhXLhpUWTc2oWWzZp7VxuqMBumloBfdyofUUaU2nKmppdnrAaP0v5_EM1PiQ6wFosv-uKPxS-tQYg"
//       }
//     ]
//         setMessages(data?.reverse())
//       } catch (err) {
//         console.error("Error fetching messages:", err);
//       } finally {
//         setMessagesLoading(false);
//       }
//     }
//     fetchMessages();
//   }, [selectedConversation]);

  const ConversationList = (
    <List
      itemLayout="horizontal"
      dataSource={conversations}
      renderItem={(item) => (
        <List.Item
          onClick={() => {
            setSelectedConversation(item);
            if (!screens.md) setDrawerOpen(false); // auto-close drawer on mobile
          }}
          style={{
            cursor: "pointer",
            background:
              selectedConversation?.id === item.id ? "#f0f5ff" : "transparent",
            paddingLeft: 16,
          }}
        >
          <List.Item.Meta
            avatar={<Avatar>{item.senders?.data?.[0]?.name[0]}</Avatar>}
            title={item.senders?.data?.[0]?.name}
            description={<Text type="secondary">{item.message_count} messages</Text>}
          />
        </List.Item>
      )}
    />
  );

  const handleSend = async () => {
    // if (!inputValue.trim()) return;
    // try {
    //   await axios.post(`/api/conversations/${selectedConversation.id}/send`, {
    //     message: inputValue,
    //   });
    //   setMessages((prev) => [
    //     ...prev,
    //     {
    //       id: `temp-${Date.now()}`,
    //       from: { id: "me", name: "Page" },
    //       message: inputValue,
    //       created_time: new Date().toISOString(),
    //     },
    //   ]);
    //   setInputValue("");
    // } catch (err) {
    //   console.error("Error sending message:", err);
    // }
  };

    // Always scroll to bottom when messages change
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (

   
   <Layout style={{ height: "100vh" }}>
      {/* Sidebar: Conversations */}
      <Sider
        width={300}
        style={{
          background: "#fff",
          borderRight: "1px solid #f0f0f0",
          overflowY: "auto",
        }}
      >
        <div style={{ padding: 16, fontWeight: "bold" }}>Conversations</div>
        {loadingConversations ? (
          <Spin style={{ margin: "20px auto", display: "block" }} />
        ) : (
            <div>
          <List
            itemLayout="horizontal"
            dataSource={conversations}
            renderItem={(item) => (
              <List.Item
                onClick={() => { setMessages([]);setSelectedConversation(item)}}
                style={{
                  cursor: "pointer",
                  background:
                    selectedConversation?.id === item.id ? "#f0f5ff" : "transparent",
                  paddingLeft: 16,
                }}
              >
                <List.Item.Meta
                  avatar={<Avatar>{item.participants?.data?.[1]?.username[0]}</Avatar>}
                  title={item.participants?.data?.[1]?.username}
                  description={
                    <Text type="secondary">{new Date(item.updated_time)?.toLocaleString()}</Text>
                  }
                />
              </List.Item>
            )}
          />
          <Button color="primary" variant="solid" block onClick={() => setLoadMoreConversations(true)} >Load More</Button>
          </div>
        )}
      </Sider>

      {/* Content: Messages */}
      <Content style={{ display: "flex", flexDirection: "column", background: "#fff" }}>
        {selectedConversation ? (
          <>
            {/* Chat messages */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                padding: 16,
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
            >
                {
                    chatsAfter && 
                        <Button color="default" variant="outlined" block onClick={() => setSelectedConversation({
                            ...selectedConversation,
                            after: chatsAfter
                        }) } >Load Older chats</Button>

                }

                {messages?.map((msg) => {
                    const senderId = msg.from?.id || msg.to?.data?.[0]?.id;
                    const isSender = senderId == selectedConversation?.participants?.data?.[0]?.id;

                    return (
                        <ChatMessage
                        key={msg.id}
                        msg={msg}
                        isSender={isSender}
                        />
                    );
                    })}

           
              <div ref={messagesEndRef} />
            </div>

            {/* Input area fixed at bottom */}
            <div
              style={{
                borderTop: "1px solid #f0f0f0",
                padding: "8px 16px",
                display: "flex",
                gap: 8,
              }}
            >
              <TextArea
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                autoSize={{ minRows: 1, maxRows: 4 }}
                placeholder="Type a message..."
                onPressEnter={(e) => {
                  if (!e.shiftKey) {
                    e.preventDefault();
                    handleSend();
                  }
                }}
              />
              <Button
                type="primary"
                icon={<SendOutlined />}
                onClick={handleSend}
                disabled={!inputValue.trim()}
              />
            </div>
          </>
        ) : (
          <div style={{ textAlign: "center", marginTop: 100 }}>
            <Text type="secondary">Select a conversation to view messages</Text>
          </div>
        )}
      </Content>
    </Layout>

  );
}
